module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("6UgT0"))).then(() => parcelRequire('aAuK0'));